import { Alert, Snackbar } from '@mui/material'
import React, { Dispatch, SetStateAction, SyntheticEvent } from 'react'
import { useStyles } from './styles'

interface ICustomAlert {
  open: boolean
  message: string
  setOpen: Dispatch<SetStateAction<boolean>>
  severity?: 'error' | 'warning' | 'info' | 'success'
}

const CustomAlert: React.FC<ICustomAlert> = ({
  open,
  message,
  severity = 'error',
  setOpen,
}) => {
  const classes = useStyles()

  const handleCloseAlert = (event: SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={5000}
      onClose={handleCloseAlert}
      children={
        <Alert
          severity={severity}
          variant='standard'
          onClose={handleCloseAlert}
          className={severity === 'error' ? classes.erroAlert : ''}
          sx={{
            // Mensagens do backend podem ser longas (ex.: a lista inteira de colunas aceitas) e
            // sem limite o toast estoura a largura da tela e fica ilegível.
            maxWidth: 'min(600px, calc(100vw - 48px))',
            '& .MuiAlert-message': {
              overflowWrap: 'anywhere',
              maxHeight: '40vh',
              overflowY: 'auto',
            },
          }}
        >
          {message}
        </Alert>
      }
    />
  )
}

export default CustomAlert